import { createContext, useState } from 'react';

import { Theme, ThemeProvider, createTheme } from '@mui/material';

type ThemeContextType = {
  themeName: string;
  toggleTheme: (themeName: string) => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  themeName: 'darkTheme',
  toggleTheme: () => {},
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  typography: {
    fontSize: 14,
    fontFamily: 'roboto',
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
  },
  typography: {
    fontSize: 14,
    fontFamily: 'roboto',
  },
});

function themeSelector(theme: string): Theme {
  return themeMap[theme];
}

const themeMap: { [key: string]: Theme } = {
  darkTheme,
  lightTheme,
};

interface Props {
  children: React.ReactNode;
}

const ThemeProviderWrapper = ({ children }: Props) => {
  const curThemeName = localStorage.getItem('appTheme') || 'darkTheme';
  const [themeName, setThemeName] = useState(curThemeName);
  const theme = themeSelector(themeName);
  const toggleTheme = (themeName: string): void => {
    localStorage.setItem('appTheme', themeName);
    setThemeName(themeName);
  };

  return (
    <ThemeContext.Provider value={{ themeName, toggleTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProviderWrapper;
